import { fetchWithAuth, ApiError } from './client';

export const mapsApi = {
  async preferences(useMemory, isRequestCurrent) {
    return fetchWithAuth('/json/maps/preferences', { method: 'POST', body: { useMemory }, isRequestCurrent, timeoutMs: 18000, networkRetries: 0 });
  },
  async recommendations(input, isRequestCurrent) {
    return fetchWithAuth('/json/maps/recommendations', { method: 'POST', body: input, isRequestCurrent, timeoutMs: 45000, networkRetries: 0 });
  },
  async place(place, isRequestCurrent) {
    return fetchWithAuth('/json/maps/place', {
      method: 'POST', body: { placeId: place.placeId, dataId: place.dataId, gps: place.gps },
      isRequestCurrent, timeoutMs: 20000, networkRetries: 0,
    });
  },
  async placeSummary(place, isRequestCurrent) {
    return fetchWithAuth('/json/maps/place/summary', {
      method: 'POST', body: { placeId: place.placeId, dataId: place.dataId, gps: place.gps },
      isRequestCurrent, timeoutMs: 40000, networkRetries: 0,
    });
  },
  async approximateLocation(isRequestCurrent = () => true) {
    const checkCurrent = () => {
      if (!isRequestCurrent()) throw new ApiError('This request is no longer active.', 401, { code: 'REQUEST_INVALIDATED', silent: true });
    };
    const locate = body => fetchWithAuth('/json/maps/location', {
      method: 'POST', body, isRequestCurrent, timeoutMs: 8000, networkRetries: 0,
    });
    checkCurrent();
    let data = await locate({});
    checkCurrent();
    if (data.needsClientIp) {
      // Local development/LAN connections don't expose the browser's public IP
      // to our backend. This runs only after the user's device lookup fails.
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      let address;
      try {
        const response = await fetch('https://api.ipify.org?format=json', {
          signal: controller.signal, credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer',
        });
        if (!response.ok) throw new Error('Unable to determine your area. Enter a city or address.');
        address = await response.json();
      } finally { clearTimeout(timeout); }
      checkCurrent();
      if (typeof address?.ip !== 'string' || address.ip.length > 45) throw new Error('Unable to determine your area. Enter a city or address.');
      data = await locate({ publicIp: address.ip });
      checkCurrent();
    }
    if (data.error || data.source !== 'network' || !data.area ||
        !Number.isFinite(data.coordinates?.lat) || !Number.isFinite(data.coordinates?.lng) ||
        Math.abs(data.coordinates.lat) > 90 || Math.abs(data.coordinates.lng) > 180) {
      throw new Error('Unable to determine your area. Enter a city or address.');
    }
    return data;
  },
  async search(input, isRequestCurrent) {
    const data = await fetchWithAuth('/json/maps/search', {
      method: 'POST', body: input, isRequestCurrent, timeoutMs: 45000, networkRetries: 0,
    });
    if (data.error) throw new ApiError(data.message || 'Unable to find places.', 400, data);
    return data;
  },
};
